import { render, staticRenderFns } from "./ArchivePlayers.vue?vue&type=template&id=1dbda73b&"
import script from "./ArchivePlayers.vue?vue&type=script&lang=js&"
export * from "./ArchivePlayers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports